import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "@/firebase";
import { addLoadingTask, deleteLoadingTask } from "@/store/uiSlice";
import { setUserAccess } from '../slice';
import { OrgAccess } from "@/types";

export const accessApi = createApi({
  reducerPath: "userAccess",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["userAccess"],
  endpoints: (builder) => ({
    fetchAccess: builder.query({
      queryFn: async (userId: string, { dispatch }) => {
        const TASK = "Accesos";

        try {
          dispatch(addLoadingTask(TASK));
          const collectionRef = collection(db, `users/${userId}/access`);

          const response = await getDocs(collectionRef).then((querySnapshot) => {
            return querySnapshot.docs.reduce((acc, doc: any) => {
              return [...acc, { ...doc.data(), id: doc.id }];
            }, [] as OrgAccess[]);
          });

          dispatch(setUserAccess(response));

          return { data: response };
        } catch (error) {
          return { error };
        } finally {
          dispatch(deleteLoadingTask(TASK));
        }
      },
      providesTags: ["userAccess"],
    }),
  }),
});

export const {
  useFetchAccessQuery,
} = accessApi;
